import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const userProfileApi = createApi({
    reducerPath: 'userProfile',
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['Profile'],
    endpoints: (builder) => ({

        getUserProfile: builder.query({
            query: () => `/api/users/user-info`,
            transformResponse: (res) => res.data,
            providesTags: ['Profile'],
        }),

        updateProfile: builder.mutation({
            query: (data) => ({
                url: `/api/users/update-user-info`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Profile'],
        }),

        changePassword: builder.mutation({
            query: (data) => ({
                url: `/api/users/update-user-password`,
                method: 'POST',
                body: data,
            }),
        }),

    }),
});

export const {
    useGetUserProfileQuery,
    useUpdateProfileMutation,
    useChangePasswordMutation
} = userProfileApi;